G.BoardCandy = G.BoardCandy || {};

G.BoardCandy.CandyStatus = function(config) {

  this.config = config;

  this.signals = {
    onRemove: new Phaser.Signal(),
    onHpChange: new Phaser.Signal(),
    checkIfIsMatching: new Phaser.Signal(),
  };
};

G.BoardCandy.CandyStatus.prototype = {
  init: function(candy, config) {
    this.candy = candy;
    this.postRandomPhase = candy.postRandomPhase;
    this.editorSymbol = G.Utils.defined(config.editorSymbol, "");
  },

  isBlockingMove: function() {
    return true;
  },

  isBlockingMatch: function() {
    return false;
  },

  // onMatch and onHit return true, if match should be passed to base type
  onMatch: function() {
    return true;
  },

  changeMatchToken: function(token) {
    return token;
  },

  onHit: function() {
    return true;
  },

  remove: function() {
    this.onRemove.dispatch();
  },

  isHpBased: function() {
    return this.config.hpMax || false;
  },

  export: function() {
    if (this.isHpBased()) {
      return this.editorSymbol + "|" + this.hp;
    } else {
      return this.editorSymbol;
    }
  },

  getEditorSymbol: function() {
    return this.editorSymbol;
  },

  hasTag: function(tag) {
    return false;
  },

  changeHp: function(newHp) {
    var clampedHp = game.math.clamp(newHp, 0, this.config.hpMax);

    if (this.hp === clampedHp) return;

    var oldHp = this.hp;
    this.hp = clampedHp;

    if (this.hp === 0) {
      this.signals.onRemove.dispatch();
      this.remove();
    } else {
      this.signals.onHpChange.dispatch(this.hp, oldHp);
    }
  },

  // for editor
  changeForEditor: function() {
    console.log("loop loopThroughHp")
    if (!this.isHpBased()) return;

    console.log("hp", this.hp, "maxHp", this.config.hpMax);
    if (this.hp === this.config.hpMax) {
      console.log("change to zero");
      this.changeHp(0);
    } else {
      this.changeHp(this.hp+1);
    }
  },

  passMatchable: function(matchable) {
    return matchable;
  },

  markPostRandomPhase: function() {
    this.postRandomPhase = true;
  },
};